import React from 'react';

// Captura errores de render. Su caso principal: tras un redeploy de Vercel los
// chunks viejos (con hash en el nombre) dejan de existir, y al navegar a una ruta
// lazy el import() se rechaza con un ChunkLoadError. Sin este boundary, React
// desmonta todo el árbol → pantalla en blanco hasta un refresh manual.
//
// Estrategia: ante un error de chunk, recargar la página una vez para traer el
// bundle nuevo. Anti-bucle: si ya recargamos hace menos de 10s (deploy realmente
// roto, no desincronización), no recargamos de nuevo y mostramos un botón de
// reintento en lugar de recargar en loop.
function esChunkError(error) {
  const msg = String((error && error.message) || error || '');
  return (
    (error && error.name === 'ChunkLoadError') ||
    /Loading chunk|Loading CSS chunk|dynamically imported module|Failed to fetch dynamically imported/i.test(msg)
  );
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    if (esChunkError(error)) {
      const last = Number(sessionStorage.getItem('chunkReloadTs') || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem('chunkReloadTs', String(Date.now()));
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'60vh', gap:16, padding:24, textAlign:'center' }}>
          <p style={{ color:'var(--text, #333)', fontSize:16, margin:0 }}>
            Ocurrió un error al cargar esta sección.
          </p>
          <button
            onClick={() => { sessionStorage.removeItem('chunkReloadTs'); window.location.reload(); }}
            style={{ padding:'8px 18px', borderRadius:8, border:'1px solid var(--border, #ccc)',
                     background:'var(--accent, #2563eb)', color:'#fff', cursor:'pointer', fontSize:14 }}
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
